import { Injectable } from '@angular/core';

import {
  CreateOffboardingRoleGQL,
  DeleteOffboardingRoleGQL,
  GetOffboardingRolesGQL,
  UpdateOffboardingRoleGQL
} from '../../../generated/graphql';

@Injectable({
  providedIn: 'root'
})
export class OffboardingService {

  constructor(
    private getOffboardingRolesGQL: GetOffboardingRolesGQL,
    private createOffboardingRoleGQL: CreateOffboardingRoleGQL,
    private updateOffboardingRoleGQL: UpdateOffboardingRoleGQL,
    private deleteOffboardingRoleGQL: DeleteOffboardingRoleGQL
  ) { }

  getAllRoles() {
    return this.getOffboardingRolesGQL.fetch({}, {fetchPolicy: 'no-cache'});
  }

  getRoleForCompany(id: string) {
    return this.getOffboardingRolesGQL.fetch({company: id});
  }

  createRole(input) {
    return this.createOffboardingRoleGQL.mutate({input});
  }

  updateRole(id, input) {
    return this.updateOffboardingRoleGQL.mutate({id, input});
  }

  deleteRole(id) {
    return this.deleteOffboardingRoleGQL.mutate({id});
  }
}
